export const API_CONFIG = {
  // Methods that have been migrated to Salesforce
  // Add method names here as you migrate them
  salesforceMethods: [
    // "getContact",
    "getUserProfile",
    "getReqInfo",
    "getInstitutionApi",
    "updateSubscription",
    "createOrUpdateInstitutionEnquiry",
    "getInstitutionEnquiryById",
    "getChildContacts",
    // 'updateChildUserStatus',
    "createOrUpdateMultiuser",
    "deleteAppIdentifier",
  ],
};
